import { TFunction } from 'i18next';

export const VideoPages = {
  DETAILS: 'details',
  ANALYTICS: 'analytics',
  TRIM: 'trim',
  SEND_AND_SHARE: 'send-and-share',
  FOLDER_SHARE: 'folder-share',
  FOLDER_SHARE_OEM: 'folder-share-oem',
};

export const getArchiveView = (t: TFunction) => [
  {
    value: '1',
    text: t('Yes'),
  },
  {
    value: '0',
    text: t('No'),
  },
];

export enum ShareWithTarget {
  Customer = 'customer',
  Reseller = 'reseller',
  EntireOrganization = 'Entire Organization',
}
